import React, { createContext, useEffect, useRef, useState } from 'react';
import { Loader } from './Loader';
import { useAxios } from './util/use-axios';
import { isNil } from 'lodash/fp';
import { useHistory } from 'react-router-dom';

export const AuthContext = createContext();

const AuthContextProvider = (props) => {
  const [isLoggedIn, setLoggedIn] = useState(
    () => !isNil(localStorage.ACCESS_TOKEN),
  );
  const { loading, axiosHttp } = useAxios();
  const phone = useRef('');
  const history = useHistory();

  const redirectUri = useRef('/requests');

  useEffect(() => {
    const { href, origin, pathname } = window.location;

    if (!isLoggedIn && pathname !== '/login') {
      redirectUri.current = href.slice(origin.length);

      history.replace('/login');
    }
  }, [history, isLoggedIn]);

  const login = async (mobilePhone) => {
    phone.current = mobilePhone;
    const params = new URLSearchParams(window.location.search);
    const action = params.get('action');
    const rid = params.get('rid');

    try {
      const res = await axiosHttp('/api/auth/login', {
        method: 'post',
        payload: { mobilePhone, action, rid },
      });
      return { message: res?.data?.message };
    } catch (err) {
      throw err;
    }
  };

  const verifyCode = async (code) => {
    try {
      const res = await axiosHttp('/api/auth/verify', {
        method: 'post',
        payload: { mobilePhone: phone.current, code },
      });
      const users = res.data??[];
      return users;
    } catch (err) {
      throw err;
    }
  };

  const verify = async (userId) => {
    try {
      const res = await axiosHttp('/api/auth/verify/user', {
        method: 'post',
        payload: { mobilePhone: phone.current, userId },
      });
      const { accessToken, refreshToken, SAMLResponse } = res.data;

	    if (!SAMLResponse) {
		    localStorage.ACCESS_TOKEN = accessToken;
		    localStorage.REFRESH_TOKEN = refreshToken;

		    setLoggedIn(true);

		    return { redirectUri: redirectUri.current };
	    } else {
		    document.body.innerHTML = "<form method='post' name='redir' action='https://globalacademy.ifipartners.org'><input type='hidden' name='SAMLResponse' value='" + SAMLResponse + "'/></form>";
		    document.forms['redir'].submit();
	    }
    } catch (err) {
      throw err;
    }
  };

  const logOut = () => {
    localStorage.removeItem('REFRESH_TOKEN');
    localStorage.removeItem('ACCESS_TOKEN');
    setLoggedIn(false);
  };

  return (
    <AuthContext.Provider value={{ isLoggedIn, login, verifyCode, verify, logOut }}>
      {loading && <Loader />}
      {props.children}
    </AuthContext.Provider>
  );
};

export { AuthContextProvider };
